<template>
  <div>
    <template v-if="loaded">
      <div class="mb-2 mt-4">
        <h4 class="is-pulled-left">
          {{ $t("bnpl:purchase.cart.list.title") }}
        </h4>
      </div>
      <FieldListing
        :data="purchaseItems"
        :columns="tableColumns"
        :searchable="false"
        :paginated="false"
        :backend-sorting="false"
      />
    </template>

    <div v-else class="column">
      <b-skeleton width="30%" :animated="true"></b-skeleton>
      <b-skeleton width="70%" :animated="true"></b-skeleton>
      <b-skeleton width="20%" :animated="true"></b-skeleton>
      <b-skeleton width="60%" :animated="true"></b-skeleton>
      <b-skeleton width="40%" :animated="true"></b-skeleton>
      <b-skeleton width="50%" :animated="true"></b-skeleton>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { localizedFormatter } from "@/utils/util";

export default {
  name: "BnplPurchaseCartTile",
  components: {
    FieldListing: () => import("@/components/FieldListing.vue"),
  },
  props: {
    purchaseId: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      tableColumns: [
        {
          field: "identifier",
          label: "bnpl:purchase.cart.list_header.identifier",
          format: (row) => {
            return row.identifier;
          },
        },
        {
          field: "externalId",
          label: "bnpl:purchase.cart.list_header.external_id",
          format: (row) => {
            return row.externalId;
          },
        },
        {
          field: "name",
          label: "bnpl:purchase.cart.list_header.name",
          format: (row) => {
            return row.name;
          },
        },
        {
          field: "price",
          label: "bnpl:purchase.cart.list_header.price",
          format: (row) => {
            return localizedFormatter(this.country.languageIso).money(
              this.currency,
              row.price
            );
          },
        },
        {
          field: "quantity",
          label: "bnpl:purchase.cart.list_header.quantity",
          format: (row) => {
            return (
              row.quantity +
              " " +
              this.$t("bnpl:purchase.cart.list_header.piece")
            );
          },
        },
      ],
    };
  },
  async created() {
    await this.fetch();
    this.loaded = true;
  },
  computed: {
    ...mapGetters({
      getPurchase: "bnplPurchase/get",
      country: "i18n/country",
    }),
    purchase() {
      return this.getPurchase(this.purchaseId);
    },
    purchaseItems() {
      if (!!this.purchase?.items) return this.purchase.items;
      return [];
    },
  },
  methods: {
    ...mapActions({
      download: "drawer/download",
      fetchPurchase: "bnplPurchase/fetch",
    }),
    async fetch() {
      await this.fetchPurchase(this.purchaseId);
    },
  },
};
</script>
